import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=25d8c589&scoped=true&"
import script from "./Item.vue?vue&type=script&lang=js&"
export * from "./Item.vue?vue&type=script&lang=js&"
import style0 from "./Item.vue?vue&type=style&index=0&id=25d8c589&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d8c589",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25d8c589')) {
      api.createRecord('25d8c589', component.options)
    } else {
      api.reload('25d8c589', component.options)
    }
    module.hot.accept("./Item.vue?vue&type=template&id=25d8c589&scoped=true&", function () {
      api.rerender('25d8c589', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/MeetingNote/Item.vue"
export default component.exports